import React from 'react';
import classNames from 'classnames';
import { omit } from 'lodash';
import withFontClassName from '../../hoc/with-font-class-name';
import styles from './button.scss';

export type ButtonProps = {
  component?: React.ElementType;
  className?: string;
  contentFontClassName?: string;
  type?: string | string[];
  isSecondary?: boolean;
  isSubmit?: boolean;
  isReset?: boolean;
  isMuted?: boolean;
  children?: React.ReactNode;
  useFixedColor?: boolean;
  keepFocusStyles?: boolean;
} & Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> & {
    [dataAttribute: `data-${string}`]: unknown;
  };

const Button: React.FC<ButtonProps> = ({
  component: Component = 'button',
  className,
  contentFontClassName,
  isSecondary,
  isSubmit,
  isReset,
  isMuted,
  children,
  type,
  useFixedColor,
  keepFocusStyles,
  ...otherProps
}) => {
  const isPrimary = !isSecondary;
  let colorsClassName;

  if (useFixedColor) {
    colorsClassName = isPrimary ? styles.fixedPrimary : styles.fixedSecondary;
  } else {
    colorsClassName = classNames(
      isPrimary ? 'blog-button-background-color' : 'blog-button-border-color',
      isPrimary ? 'blog-button-primary-text-color' : 'blog-button-secondary-text-color',
    );
  }

  const containerClassName = classNames(
    keepFocusStyles && styles.clipboardFocusRing,
    styles.button,
    className,
    contentFontClassName,
    colorsClassName,
    type,
    {
      [styles.secondary]: isSecondary,
      [styles.isMuted]: isMuted,
    },
  );
  const componentProps = omit(
    otherProps,
    'isSubmit',
    'currentUser',
    'isBlocked',
    'dispatch',
    'viewMode',
    'isDemoMode',
    'openModal',
    'isAuthenticated',
    'titleFontClassName',
    'contentFontClassNameWithStyle',
    'metadataFontClassName',
    'isPrivate',
  );

  return (
    <Component
      className={containerClassName}
      type={(isSubmit && 'submit') || (isReset && 'reset') || 'button'}
      {...componentProps}
    >
      <span className={styles.wrapper}>{children}</span>
    </Component>
  );
};

export default withFontClassName(Button);
